import {URL} from '../index';
import axios from '../../http';

export function getSupplyOrderBySku(params={}) {
    return axios.post(`${URL}/getSupplyOrderBySku`,params);
}